export const reuseCampaign = campaignId => {
  var _window;
  (_window = window) == null || (_window = _window.ModuleRegistry) == null || _window.invoke('EmailMarketing.reuseCampaign', campaignId);
};
//# sourceMappingURL=interactions.js.map